// extracted by mini-css-extract-plugin
export default {"row":"About_row__T61ED","col":"About_col__sFafN","colMax":"About_colMax__wqbYo","rowSm":"About_rowSm__PCg5t","colSm":"About_colSm__Sn1HJ","colMaxSm":"About_colMaxSm__SEtIZ"};